// PhaseToolbar  Component

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Button from '../../../common/button/button.jsx'
import IntlMessage from '../../../../common/common/intl/intl_message.jsx'

class PhaseToolbar extends PureComponent {
  static get propTypes () {
    return {
      onCreateEstimate: PropTypes.func,
      onCreateInvoice: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onCreateEstimate: null,
      onCreateInvoice: null
    }
  }

  render () {
    const { onCreateEstimate, onCreateInvoice } = this.props

    return (
      <div className='budgettoolbar'>
        <span className='label'>
          <IntlMessage ident='project.budgetContent.labelToolbar' />
        </span>
        <Button
          type='default'
          title='project.budgetContent.createEstimate'
          className='toolaction'
          canHover
          onClick={onCreateEstimate}
        />
        <Button
          type='default'
          title='project.budgetContent.createInvoice'
          canHover
          className='toolaction'
          onClick={onCreateInvoice}
        />
      </div>
    )
  }
}

export default PhaseToolbar
